import { combineReducers, compose, createStore as _createStore, applyMiddleware, CombinedState } from 'redux';
import thunk from 'redux-thunk';
import { IApplicationState, TReduxActions, IThunkContext, IReduxStore } from '../../types/redux';

import * as reducers from '../../reducers';

let storeReminder: IReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(
  initialState: Pick<IApplicationState, 'page'>,
  debugEnabled: boolean,
  context: IThunkContext,
) {
  const _reducers = combineReducers<IApplicationState, TReduxActions>(reducers);

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(
    applyMiddleware(thunk.withExtraArgument(context)),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) as any;

  const createStore = (): IReduxStore =>
    _createStore<CombinedState<IApplicationState>, TReduxActions, IApplicationState, {}>(
      _reducers,
      initialState,
      storeEnchancers,
    );

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(_reducers);

    return storeReminder;
  }

  return createStore();
}
